const admin = {
  // ==================== ADMIN VIEW ====================
  'admin.title': 'Administrator Area',
  'admin.back': 'Back',
  'admin.tabSettings': 'Settings',
  'admin.tabUsers': 'Users',
  'admin.tabRoles': 'Roles',
  'admin.tabOciShops': 'OCI Shops',
  'admin.tabInternalShops': 'Internal Shops',
  'admin.tabMapping': 'Mapping',
  'admin.tabApplication': 'Application',
  'admin.tabAdapter': 'SAP Adapter',
  'admin.tabAbAdapter': 'AB: Z-REST vs. SOAP',
  'admin.tabSapConnectivity': 'SAP Connectivity',

  // ==================== ADMIN SAP-ADAPTER TEST PANEL ====================
  'admin.adapter.intro': 'Internal diagnostics against the SAP adapter (SBX) — not a customer feature.',
  'admin.adapter.pingTitle': 'Connectivity (Ping)',
  'admin.adapter.pingButton': 'Send ping',
  'admin.adapter.readTitle': 'Read BANF (BAPI_PR_GETDETAIL)',
  'admin.adapter.readButton': 'Read BANF',
  'admin.adapter.createTitle': 'Create BANF — Dry-run (BAPI_PR_CREATE)',
  'admin.adapter.createHint': 'TESTRUN is hardcoded server-side — this can never create a real BANF.',
  'admin.adapter.createButton': 'Run dry-run',
  'admin.adapter.resultTitle': 'Result',
  'admin.adapter.success': 'Request succeeded.',
  'admin.adapter.error': 'Request failed.',
  'admin.adapter.realTitle': 'Create REAL BANF (no undo)',
  'admin.adapter.realHint': 'No TESTRUN — creates a genuine, permanent BANF in SAP (BAPI_PR_CREATE + COMMIT).',
  'admin.adapter.realButton': 'Create real BANF',
  'admin.adapter.realArmedWarning': 'Are you sure? This cannot be undone.',
  'admin.adapter.realConfirmButton': 'Yes, create it now',
  'admin.adapter.realCancelButton': 'Cancel',
  'admin.adapter.deleteTitle': 'Delete / undo BANF',
  'admin.adapter.deleteHint': 'Only sets/clears the deletion flag (BAPI_PR_CHANGE) — reversible, unlike creating one.',
  'admin.adapter.deleteDryRunButton': 'Dry-run (preview, writes nothing)',
  'admin.adapter.deleteButton': 'Delete BANF item',
  'admin.adapter.deleteArmedWarning': 'Are you sure?',
  'admin.adapter.deleteConfirmButton': 'Yes, delete now',
  'admin.adapter.deleteCancelButton': 'Cancel',

  // ==================== ADMIN AB-ADAPTER COMPARE PANEL (Z-REST vs. SOAP POC) ====================
  'admin.abAdapter.intro': 'AB module (Auftragsbestaetigung) POC: compare the Z-REST and SOAP publication paths against the same SBX data — read-only, no order confirmation here.',
  'admin.abAdapter.modeTitle': 'Publication path',
  'admin.abAdapter.modeZRest': 'Z-REST',
  'admin.abAdapter.modeSoap': 'SOAP',
  'admin.abAdapter.pingTitle': 'Connectivity (Ping)',
  'admin.abAdapter.pingButton': 'Send ping',
  'admin.abAdapter.readTitle': 'Read open PO items (read-only)',
  'admin.abAdapter.readButton': 'Read PO',
  'admin.abAdapter.resultTitle': 'Result',
  'admin.abAdapter.success': 'Request succeeded.',
  'admin.abAdapter.error': 'Request failed.',

  // ==================== ADMIN SAP CONNECTIVITY (Customer/System/Connection config) ====================
  'admin.sapConnectivity.intro': 'DB-backed SAP connectivity configuration — customer, system (environment), and connection (transport type) instead of scattered env vars.',
  'admin.sapConnectivity.success': 'Saved.',
  'admin.sapConnectivity.error': 'Request failed.',
  'admin.sapConnectivity.newCustomerTitle': 'Add customer',
  'admin.sapConnectivity.customerCode': 'Customer code',
  'admin.sapConnectivity.customerName': 'Customer name',
  'admin.sapConnectivity.contactName': 'Contact name',
  'admin.sapConnectivity.contactEmail': 'Contact email',
  'admin.sapConnectivity.contactPhone': 'Contact phone',
  'admin.sapConnectivity.addCustomerButton': 'Add customer',
  'admin.sapConnectivity.customersTitle': 'Customers',
  'admin.sapConnectivity.noCustomers': 'No customers configured yet.',
  'admin.sapConnectivity.environment': 'Environment',
  'admin.sapConnectivity.mandant': 'SAP client (Mandant)',
  'admin.sapConnectivity.addSystemButton': 'Add system',
  'admin.sapConnectivity.connectionType': 'Connection type',
  'admin.sapConnectivity.baseUrl': 'Base URL (internal)',
  'admin.sapConnectivity.publicUrl': 'Public URL (optional)',
  'admin.sapConnectivity.technicalUser': 'Technical user',
  'admin.sapConnectivity.credentialRef': 'Credential ref (env var name)',
  'admin.sapConnectivity.password': 'Password (stored encrypted)',
  'admin.sapConnectivity.passwordHint': 'Optional — either a credential reference (env var name) or a password here (encrypted at rest, AES-256-GCM). If both are set, the stored password wins.',
  'admin.sapConnectivity.passwordStored': 'password stored',
  'admin.sapConnectivity.addConnectionButton': 'Add connection',
  'admin.sapConnectivity.testButton': 'Test connection',
  'admin.sapConnectivity.default': 'default',

  // ==================== ADMIN GENERAL SETTINGS ====================
  'admin.settings.title': 'General Settings',
  'admin.settings.saved': 'Settings saved successfully!',
  'admin.settings.saveError': 'Error saving settings',

  // ==================== ADMIN LOGO SETTINGS ====================
  'admin.logo.title': 'Logo',
  'admin.logo.maxSize': 'The logo must not exceed 2MB.',
  'admin.logo.select': 'Select Logo',
  'admin.logo.formats': 'Supported formats: PNG, JPG, GIF (max. 2MB)',

  // ==================== ADMIN SMTP SETTINGS ====================
  'admin.smtp.title': 'SMTP Settings',
  'admin.smtp.server': 'SMTP Server',
  'admin.smtp.username': 'Username',
  'admin.smtp.password': 'Password',
  'admin.smtp.senderEmail': 'Sender Email',
  'admin.smtp.tls': 'Use secure connection (TLS/SSL)',
  'admin.smtp.notificationsEnabled': 'Email notifications enabled',
  'admin.smtp.notificationsDisabled': 'Email notifications are disabled!',
  'admin.smtp.notificationsHint': 'When disabled, no automatic emails will be sent for purchase requests or status updates',
  'admin.smtp.testConnection': 'Test SMTP Connection',
  'admin.smtp.testEmail': 'Send Test Email',
  'admin.smtp.testing': 'Testing...',
  'admin.smtp.testSuccess': 'SMTP connection tested successfully! Test email sent to: {email}',
  'admin.smtp.testFailed': 'SMTP test failed',
  'admin.smtp.testFailedMsg': 'SMTP test failed: {error}',
  'admin.smtp.emailSuccess': 'Test email sent successfully to {email}!',
  'admin.smtp.emailFailed': 'Test email failed',
  'admin.smtp.emailFailedMsg': 'Test email failed: {error}',
  'admin.smtp.hint': 'SMTP settings are used for email notifications (e.g. PR confirmations, password reset)',

  // ==================== ADMIN WEBSITE SETTINGS ====================
  'admin.website.title': 'Website Settings',
  'admin.website.siteTitle': 'Site Title',
  'admin.website.siteTitleHint': 'Shown in the browser tab and as main title',

  // ==================== ADMIN LICENSE SETTINGS ====================
  'admin.license.title': 'License Key',
  'admin.license.softwareLicense': 'Software License Key',
  'admin.license.enter': 'Enter license key...',
  'admin.license.enterHint': 'Enter your license key to unlock advanced features',
  'admin.license.check': 'Check License',
  'admin.license.checking': 'Checking...',
  'admin.license.valid': 'License verification successful',
  'admin.license.empty': 'Please enter a license key',
  'admin.license.error': 'Error during license verification',
  'admin.license.autoError': 'Error during automatic license verification',
  'admin.license.failed': 'License verification failed: {error}',
  'admin.license.autoSaveError': 'Error auto-saving license settings',
  'admin.license.licensedProduct': 'Licensed product: {scope}',
  'admin.license.info': 'With a valid license key you get access to advanced features and premium support.',
  'admin.license.updateTitle': 'Software Update',
  'admin.license.currentVersion': 'Current version: 0.0.1',
  'admin.license.checkUpdates': 'Check for Updates',
  'admin.license.checkingUpdates': 'Checking for updates...',
  'admin.license.upToDate': 'Your software is up to date',
  'admin.license.lastChecked': 'Last checked: {date}',
  'admin.license.updateAvailable': 'Update available: Version 1.1.0',
  'admin.license.updateChanges': 'New features and bug fixes',
  'admin.license.install': 'Install',
  'admin.license.updateHint': 'Click the button to check for available updates.',

  // ==================== ADMIN MAPPING SETTINGS ====================
  'admin.mapping.title': 'Field Mappings',
  'admin.mapping.subtitle': 'Link between code and description',
  'admin.mapping.sapSyncFuture': 'SAP synchronization will be available in a future version.',
  'admin.mapping.costCenters': 'Cost Centers',
  'admin.mapping.costCenterCode': 'Cost Center',
  'admin.mapping.costCenterLabel': 'Cost Center Description',
  'admin.mapping.plants': 'Plants',
  'admin.mapping.plantCode': 'Plant',
  'admin.mapping.plantLabel': 'Plant Description',
  'admin.mapping.purchasingOrgs': 'Purchasing Organizations',
  'admin.mapping.purchasingOrgCode': 'Purchasing Organization',
  'admin.mapping.purchasingOrgLabel': 'Organization Description',
  'admin.mapping.purchasingGroups': 'Purchasing Groups',
  'admin.mapping.purchasingGroupCode': 'Purchasing Group',
  'admin.mapping.purchasingGroupLabel': 'Group Description',
  'admin.mapping.loadError': 'Error loading {type}',
  'admin.mapping.fillBothFields': 'Please fill in both fields',
  'admin.mapping.alreadyExists': 'This {type} already exists',
  'admin.mapping.added': 'Mapping added successfully',
  'admin.mapping.addError': 'Error saving mapping',
  'admin.mapping.updated': 'Mapping updated successfully',
  'admin.mapping.updateError': 'Error updating mapping',
  'admin.mapping.deleteConfirm': 'Do you really want to delete this mapping?',
  'admin.mapping.deleted': 'Mapping deleted successfully',
  'admin.mapping.deleteError': 'Error deleting mapping',
  'admin.mapping.glAccounts': 'G/L Accounts',
  'admin.mapping.glAccountCode': 'G/L Account',
  'admin.mapping.glAccountLabel': 'G/L Account Description',
  'admin.mapping.orders': 'Internal Orders',
  'admin.mapping.orderCode': 'Internal Order',
  'admin.mapping.orderLabel': 'Order Description',
  'admin.mapping.syncSap': 'Sync with SAP',
  'admin.mapping.refresh': 'Refresh',
  'admin.mapping.addNew': 'Add new {type}',
  'admin.mapping.existing': 'Existing {type} ({count})',
  'admin.mapping.empty': 'No {type} available yet',
  'admin.mapping.emptyHint': 'Add a new mapping above',

  // ==================== ADMIN PERMISSION PROFILES ====================
  'admin.permissions.title': 'Permission Profiles',
  'admin.permissions.subtitle': 'Create profiles as templates for user permissions',
  'admin.permissions.newProfile': 'New Profile',
  'admin.permissions.empty': 'No permission profiles created yet',
  'admin.permissions.createFirst': 'Create First Profile',
  'admin.permissions.hint': 'Note:',
  'admin.permissions.hintText': 'Changes to profiles take effect immediately for all assigned users. The effective permission of a user is the union of all assigned profiles.',
  'admin.permissions.deleteConfirm': 'Do you really want to delete this profile?',
  'admin.permissions.restrictions': '{count} restrictions',
  'admin.permissions.loadError': 'Error loading profiles',
  'admin.permissions.created': 'Profile created successfully',
  'admin.permissions.updated': 'Profile updated successfully',
  'admin.permissions.deleted': 'Profile deleted successfully',
  'admin.permissions.allowAll': 'Allow all',
  'admin.permissions.tabGeneral': 'General',
  'admin.permissions.tabOrganization': 'Organization',
  'admin.permissions.tabCatalogs': 'Catalogs',
  'admin.permissions.tabFeatures': 'Features',
  'admin.permissions.profileName': 'Profile Name *',
  'admin.permissions.description': 'Description (optional)',
  'admin.permissions.maxOrderValue': 'Maximum Order Value',
  'admin.permissions.docTypes': 'Document Types',
  'admin.permissions.plants': 'Plants',
  'admin.permissions.costCenters': 'Cost Centers',
  'admin.permissions.purchasingOrgs': 'Purchasing Organizations',
  'admin.permissions.purchasingGroups': 'Purchasing Groups',
  'admin.permissions.internalShops': 'Internal Shops',
  'admin.permissions.ociShops': 'OCI Shops',
  'admin.permissions.accessProcurement': 'Access to Procurement',
  'admin.permissions.accessProcurementDesc': 'Can use the procurement module',
  'admin.permissions.accessWarehouse': 'Access to Warehouse Management',
  'admin.permissions.accessWarehouseDesc': 'Can use the warehouse management module',
  'admin.permissions.accessWorkflow': 'Access to Workflow Editor',
  'admin.permissions.accessWorkflowDesc': 'Can create and edit workflows',
  'admin.permissions.accessEInvoicing': 'Access to E-Invoicing',
  'admin.permissions.accessEInvoicingDesc': 'Can use the e-invoicing module',
  'admin.permissions.accessPm': 'Access to Plant Maintenance',
  'admin.permissions.accessPmDesc': 'Can use the plant maintenance module',
  'admin.permissions.einvoicing': 'E-Invoicing',
  'admin.permissions.pm': 'Plant Maintenance',
  'admin.permissions.orderConfirmation': 'Order Confirmation',
  'admin.permissions.createBanf': 'Create PR',
  'admin.permissions.createBanfDesc': 'Can create purchase requisitions',
  'admin.permissions.approveBanf': 'Approve PR',
  'admin.permissions.approveBanfDesc': 'Can approve purchase requisitions',
  'admin.permissions.manageFavorites': 'Manage Favorites',
  'admin.permissions.manageFavoritesDesc': 'Can save personal favorites',
  'admin.permissions.editCatalog': 'Edit catalog',
  'admin.permissions.editCatalogDesc': 'May edit internal catalog products (without admin role)',
  'admin.permissions.accessOrderConfirmation': 'Order Confirmation Capture',
  'admin.permissions.accessOrderConfirmationDesc': 'Access to the order confirmation module (upload, OCR review, PO comparison)',
  'admin.permissions.procurement': 'Procurement',
  'admin.permissions.warehouse': 'Warehouse',
  'admin.permissions.plantsCount': 'Plants: {value}',
  'admin.permissions.costCentersCount': 'Cost Centers: {value}',
  'admin.permissions.purchasingOrgsCount': 'Purch. Org: {value}',
  'admin.permissions.internalShopsCount': 'Internal Shops: {value}',
  'admin.permissions.ociShopsCount': 'OCI Shops: {value}',
  'admin.permissions.maxValue': 'Max. Value: {value}',

  // ==================== ADMIN PASSWORD CHANGE ====================
  'admin.password.title': 'Change Password',
  'admin.password.titleFor': 'Change password for {username}',
  'admin.password.current': 'Current Password',
  'admin.password.new': 'New Password',
  'admin.password.confirm': 'Confirm Password',
  'admin.password.mismatch': 'New passwords do not match',
  'admin.password.minLength': 'The new password must be at least 6 characters long',
  'admin.password.currentRequired': 'Please enter your current password',
  'admin.password.changed': 'Password changed successfully!',
  'admin.password.error': 'Error changing password',

  // ==================== ADMIN USER MANAGEMENT ====================
  'admin.users.title': 'User Management',
  'admin.users.subtitle': 'Manage system and OCI users',
  'admin.users.localUsers': 'Local Users',
  'admin.users.ociUsers': 'OCI Users',
  'admin.users.newOciUser': 'New OCI User',
  'admin.users.search': 'Search users...',
  'admin.users.filterAll': 'All Users',
  'admin.users.filterActive': 'Active only',
  'admin.users.filterInactive': 'Inactive only',
  'admin.users.loading': 'Loading users...',
  'admin.users.ociLoading': 'Loading OCI users...',
  'admin.users.usernamePasswordRequired': 'Username and password are required',
  'admin.users.noUsersFound': 'No {type}users found',
  'admin.users.noUsersExist': 'No {type}users exist',
  'admin.users.tryOtherSearch': 'Try a different search term.',
  'admin.users.createFirstLocal': 'Create the first system user to get started with management',
  'admin.users.createFirstOci': 'Create the first OCI user for SAP integration',
  'admin.users.roleAdmin': 'Administrator',
  'admin.users.roleSupervisor': 'Supervisor',
  'admin.users.rolePurchaser': 'Purchaser',
  'admin.users.newUser': 'New User',
  'admin.users.editUser': 'Edit User',
  'admin.users.changePassword': 'Change Password',
  'admin.users.deleteLocalUser': 'Delete User',
  'admin.users.editOci': 'Edit OCI User',
  'admin.users.deleteOci': 'Delete OCI User',
  'admin.users.deleted': 'User deleted successfully',
  'admin.users.created': 'Created:',

  // ==================== ADMIN USER FORM ====================
  'admin.userForm.editTitle': 'Edit User',
  'admin.userForm.createTitle': 'Create New User',
  'admin.userForm.editSubtitle': 'Change user data and permissions',
  'admin.userForm.createSubtitle': 'Create a new system user',
  'admin.userForm.username': 'Username *',
  'admin.userForm.usernameReadonly': 'The username cannot be changed',
  'admin.userForm.email': 'Email *',
  'admin.userForm.firstName': 'First Name',
  'admin.userForm.lastName': 'Last Name',
  'admin.userForm.department': 'Department',
  'admin.userForm.costCenter': 'Cost Center',
  'admin.userForm.plant': 'Plant',
  'admin.userForm.purchasingOrg': 'Purchasing Organization',
  'admin.userForm.sapUser': 'SAP User',
  'admin.userForm.purchasingGroup': 'Purchasing Group',
  'admin.userForm.requester': 'Requester',
  'admin.userForm.role': 'Role',
  'admin.userForm.rolePurchaser': 'Purchaser',
  'admin.userForm.roleSupervisor': 'Supervisor',
  'admin.userForm.roleAdmin': 'Administrator',
  'admin.userForm.isActive': 'User is active',
  'admin.userForm.changePassword': 'Change Password (optional)',
  'admin.userForm.setPassword': 'Set Password',
  'admin.userForm.newPassword': 'New Password',
  'admin.userForm.passwordRequired': 'Password *',
  'admin.userForm.confirmPassword': 'Confirm Password',
  'admin.userForm.permissionProfiles': 'Permission Profiles',
  'admin.userForm.profilesHint': 'Assigned profiles determine the user\'s permissions',
  'admin.userForm.noProfile': 'No profile assigned - user has only basic permissions',
  'admin.userForm.usernameRequired': 'Username is required',
  'admin.userForm.emailRequired': 'Email is required',
  'admin.userForm.passwordMismatch': 'Passwords do not match',
  'admin.userForm.passwordMinLength': 'The password must be at least 6 characters long',
  'admin.userForm.settingsLoadError': 'Error loading settings',
  'admin.userForm.createError': 'Error creating user',
  'admin.userForm.updateError': 'Error updating user',
  'admin.userForm.created': 'User created successfully!',
  'admin.userForm.updated': 'User updated successfully!',

  // ==================== ADMIN OCI USER FORM ====================
  'admin.ociForm.editTitle': 'Edit OCI User',
  'admin.ociForm.createTitle': 'Create New OCI User',
  'admin.ociForm.username': 'Username *',
  'admin.ociForm.password': 'Password * (plain text for SAP)',
  'admin.ociForm.passwordHint': 'Password in plain text for OCI',
  'admin.ociForm.email': 'Email',
  'admin.ociForm.company': 'Company',
  'admin.ociForm.isActive': 'User is active',

  // ==================== ADMIN DELETE CONFIRMATION ====================
  'admin.deleteUser.title': 'Delete User',
  'admin.deleteUser.confirm': 'Are you sure you want to delete the {type}user "{username}"? This action cannot be undone.',

  // ==================== ADMIN OCI USER HOOK ====================
  'admin.ociHook.loadError': 'Error loading OCI users: {error}',
  'admin.ociHook.credentialsRequired': 'Username and password are required',
  'admin.ociHook.created': 'OCI user created successfully',
  'admin.ociHook.updated': 'OCI user updated successfully',
  'admin.ociHook.deleteError': 'Error deleting OCI user',
  'admin.ociHook.deleted': 'OCI user deleted successfully',

  // ==================== ADMIN OCI SHOP MANAGEMENT ====================
  'admin.ociShops.title': 'OCI Shop Management',
  'admin.ociShops.subtitle': 'Manage external OCI-compatible online catalogs',
  'admin.ociShops.newShop': 'New OCI Shop',
  'admin.ociShops.urlConfigured': 'URL configured',
  'admin.ociShops.credentialsConfigured': 'Credentials: Configured',
  'admin.ociShops.credentialsNotConfigured': 'Credentials: Not configured',
  'admin.ociShops.empty': 'No OCI shops configured',
  'admin.ociShops.emptyDesc': 'Create your first OCI shop to integrate external catalogs',
  'admin.ociShops.createFirst': 'Create First OCI Shop',

  // ==================== ADMIN OCI SHOP EDITOR ====================
  'admin.shopEditor.editTitle': 'Edit Shop',
  'admin.shopEditor.createTitle': 'Add New Shop',
  'admin.shopEditor.subtitle': 'Configure and manage OCI shop',
  'admin.shopEditor.name': 'Shop Name',
  'admin.shopEditor.supplier': 'Supplier',
  'admin.shopEditor.url': 'OCI URL',
  'admin.shopEditor.description': 'Description',
  'admin.shopEditor.category': 'Category',
  'admin.shopEditor.categoryPlaceholder': 'e.g. Office Supplies',
  'admin.shopEditor.username': 'Username',
  'admin.shopEditor.password': 'Password',
  'admin.shopEditor.credentialsUnchanged': 'Credentials remain unchanged (leave empty)',
  'admin.shopEditor.credentialsHint': 'Leave empty to keep existing credentials',
  'admin.shopEditor.urlParams': 'OCI URL Parameters',
  'admin.shopEditor.urlParamsHint': 'Configure the URL parameters for the OCI integration',
  'admin.shopEditor.manageParams': 'Manage Parameters',
  'admin.shopEditor.isActive': 'Shop is active',

  // ==================== ADMIN OCI PARAMETER EDITOR ====================
  'admin.ociParams.title': 'Manage OCI Parameters',
  'admin.ociParams.subtitle': 'Configure URL parameters and sort via drag & drop',
  'admin.ociParams.addParam': 'Add Parameter',
  'admin.ociParams.createDefaults': 'Create Default Parameters',
  'admin.ociParams.defaultsCreated': 'Default parameters created successfully!',
  'admin.ociParams.defaultsError': 'Error creating default parameters: {error}',
  'admin.ociParams.empty': 'No parameters configured',
  'admin.ociParams.emptyHint': 'Create default parameters or add parameters manually.',
  'admin.ociParams.paramKey': 'Parameter Key',
  'admin.ociParams.paramValue': 'Value',
  'admin.ociParams.paramType': 'Type',
  'admin.ociParams.required': 'Required',
  'admin.ociParams.keyRequired': 'Parameter {index}: Key is required',
  'admin.ociParams.saved': 'Parameters saved successfully!',
  'admin.ociParams.saveError': 'Error saving parameters: {error}',
  'admin.ociParams.parameter': 'Parameter',
  'admin.ociParams.dragDrop': 'Drag & drop to sort',
  'admin.ociParams.unsavedChanges': 'Unsaved changes',
  'admin.ociParams.deleteSave': 'Save deletion',

  // ==================== ADMIN INTERNAL SHOP MANAGEMENT ====================
  'admin.internalShops.title': 'Internal Shop Management',
  'admin.internalShops.subtitle': 'Manage your own product catalogs and internal shops',
  'admin.internalShops.newShop': 'New Internal Shop',
  'admin.internalShops.loadError': 'Error loading internal shops',
  'admin.internalShops.saved': 'Shop created successfully!',
  'admin.internalShops.updated': 'Shop updated successfully!',
  'admin.internalShops.saveError': 'Error saving shop: {error}',
  'admin.internalShops.deleted': 'Shop deleted successfully!',
  'admin.internalShops.deleteError': 'Error deleting shop',
  'admin.internalShops.loading': 'Loading internal shops...',
  'admin.internalShops.empty': 'No internal shops',
  'admin.internalShops.emptyDesc': 'Create your first internal shop with your own product catalogs',
  'admin.internalShops.createFirst': 'Create First Shop',
  'admin.internalShops.internalCatalog': 'Internal Catalog',
  'admin.internalShops.deleteShop': 'Delete shop',

  // ==================== ADMIN INTERNAL SHOP FORM ====================
  'admin.shopForm.editTitle': 'Edit Internal Shop',
  'admin.shopForm.createTitle': 'Create New Internal Shop',
  'admin.shopForm.subtitle': 'Configure your own product catalog',
  'admin.shopForm.name': 'Shop Name *',
  'admin.shopForm.nameRequired': 'Shop name is required',
  'admin.shopForm.category': 'Category',
  'admin.shopForm.description': 'Description',
  'admin.shopForm.icon': 'Shop Icon',
  'admin.shopForm.selectIcon': 'Select Icon',
  'admin.shopForm.iconHint': 'Click "Select Icon" to choose a fitting emoji for your shop',
  'admin.shopForm.isActive': 'Shop is active and visible to users',
  'admin.shopForm.namePlaceholder': 'e.g. Office Supplies Shop',
  'admin.shopForm.categoryPlaceholder': 'e.g. Office Supplies',
  'admin.shopForm.descriptionPlaceholder': 'Brief description of the shop',

  // ==================== ADMIN INTERNAL SHOP DELETE MODAL ====================
  'admin.shopDelete.title': 'Delete Shop',
  'admin.shopDelete.subtitle': 'This action cannot be undone',
  'admin.shopDelete.confirm': 'Are you sure you want to delete the shop {name}? All associated products will also be removed.',

  // ==================== ADMIN PRODUCT MANAGEMENT ====================
  'admin.products.title': 'Manage Products',
  'admin.products.backToShops': 'Back to Shop Management',
  'admin.products.newProduct': 'New Product',
  'admin.products.loadError': 'Error loading products',
  'admin.products.saved': 'Product created successfully!',
  'admin.products.updated': 'Product updated successfully!',
  'admin.products.saveError': 'Error saving product: {error}',
  'admin.products.deleted': 'Product deleted successfully!',
  'admin.products.deleteError': 'Error deleting product',
  'admin.products.deleteConfirm': 'Are you sure you want to delete the product "{name}"?',
  'admin.products.search': 'Search products...',
  'admin.products.allCategories': 'All Categories',
  'admin.products.filterCategory': 'Category',
  'admin.products.filterStatus': 'Status',
  'admin.products.filterManufacturer': 'Manufacturer',
  'admin.products.filterSource': 'Source',
  'admin.products.statusActive': 'Active',
  'admin.products.statusInactive': 'Inactive',
  'admin.products.sourceSap': 'SAP',
  'admin.products.sourceInternal': 'Internal',
  'admin.products.loading': 'Loading products...',
  'admin.products.empty': 'No products',
  'admin.products.emptyFiltered': 'No matching products',
  'admin.products.createFirst': 'Create your first product for this internal shop.',
  'admin.products.changeFilter': 'Change your search criteria or filters.',
  'admin.products.colProduct': 'Product',
  'admin.products.colCategory': 'Category',
  'admin.products.colPrice': 'Price',
  'admin.products.colStatus': 'Status',
  'admin.products.colStock': 'Stock',
  'admin.products.colActions': 'Actions',
  'admin.products.unlimited': 'Unlimited',

  // ==================== ADMIN PRODUCT FORM ====================
  'admin.productForm.editTitle': 'Edit Product',
  'admin.productForm.createTitle': 'Create New Product',
  'admin.productForm.internalShop': 'Internal Shop',
  'admin.productForm.sapReadOnlyHint': 'From SAP — read-only. Master data is maintained in SAP (MM02). Only the status can be changed here.',
  'admin.productForm.sapSection': 'SAP Identification',
  'admin.productForm.baseSection': 'Basic Data',
  'admin.productForm.textsSection': 'Multilingual Texts (MAKT)',
  'admin.productForm.stockSection': 'Stock Locations (MARD)',
  'admin.productForm.sourcesSection': 'Sources',
  'admin.productForm.sources.title': 'Sources',
  'admin.productForm.sources.vendor': 'Vendor (LIFNR)',
  'admin.productForm.sources.vendorName': 'Vendor name',
  'admin.productForm.sources.vendorMaterialNo': 'Vendor material no.',
  'admin.productForm.sources.netPrice': 'Net price',
  'admin.productForm.sources.priceUnit': 'Price unit',
  'admin.productForm.sources.orderUnit': 'Order unit',
  'admin.productForm.sources.deliveryTime': 'Delivery time (days)',
  'admin.productForm.sources.isPrimary': 'Primary',
  'admin.productForm.sources.addRow': 'Add source',
  'admin.productForm.sources.removeRow': 'Remove row',
  'admin.productForm.sources.empty': 'No sources added yet.',
  'admin.productForm.sources.scaleTitle': 'Price scales',
  'admin.productForm.sources.scaleMinQty': 'From qty',
  'admin.productForm.sources.scaleAmount': 'Price',
  'admin.productForm.sources.scaleAddRow': 'Add scale',
  'admin.productForm.sources.scaleRemoveRow': 'Remove scale',
  'admin.productForm.ean': 'EAN / GTIN',
  'admin.productForm.priceUnit': 'Price Unit (PEINH)',
  'admin.productForm.materialType': 'Material Type (MTART)',
  'admin.productForm.materialTypeNone': 'Not specified',
  'admin.productForm.materialStatus': 'Material Status',
  'admin.productForm.statusActive': 'Active',
  'admin.productForm.statusBlocked': 'Blocked',
  'admin.productForm.statusDiscontinued': 'Discontinued',
  'admin.productForm.grossWeight': 'Gross Weight',
  'admin.productForm.netWeight': 'Net Weight',
  'admin.productForm.weightUnit': 'Weight Unit',
  'admin.productForm.sizeText': 'Size Text',
  'admin.productForm.profitCenter': 'Profit Center',
  'admin.productForm.texts.addLang': 'Add language',
  'admin.productForm.texts.removeLang': 'Remove language',
  'admin.productForm.texts.name': 'Name',
  'admin.productForm.texts.namePlaceholder': 'Product name in this language',
  'admin.productForm.texts.description': 'Description',
  'admin.productForm.texts.descriptionPlaceholder': 'Product description in this language',
  'admin.productForm.stock.plant': 'Plant',
  'admin.productForm.stock.storageLocation': 'Storage Location',
  'admin.productForm.stock.type': 'Stock Type',
  'admin.productForm.stock.typeOwn': 'Own',
  'admin.productForm.stock.typeVendorConsignment': 'Consignment',
  'admin.productForm.stock.typeAtVendor': 'At Vendor',
  'admin.productForm.stock.vendor': 'Vendor (LIFNR)',
  'admin.productForm.stock.qty': 'Quantity',
  'admin.productForm.stock.status': 'Status',
  'admin.productForm.stock.addRow': 'Add storage location',
  'admin.productForm.stock.removeRow': 'Remove row',
  'admin.productForm.stock.empty': 'No storage locations defined yet.',
  'admin.productForm.name': 'Product Name',
  'admin.productForm.nameRequired': 'Product name is required',
  'admin.productForm.sku': 'SAP Number / Item Number',
  'admin.productForm.description': 'Description',
  'admin.productForm.price': 'Price',
  'admin.productForm.priceRequired': 'A valid price is required',
  'admin.productForm.currency': 'Currency',
  'admin.productForm.unit': 'Unit',
  'admin.productForm.productGroup': 'Product Group',
  'admin.productForm.productGroupPlaceholder': 'e.g. Office Supplies, IT Equipment',
  'admin.productForm.supplierArtNo': 'Supplier Article Number',
  'admin.productForm.preferredVendor': 'Preferred Vendor',
  'admin.productForm.fixedVendor': 'Fixed Vendor',
  'admin.productForm.costCenter': 'Cost Center',
  'admin.productForm.purchasingOrg': 'Purchasing Organization',
  'admin.productForm.plant': 'Plant',
  'admin.productForm.stock': 'Stock Quantity',
  'admin.productForm.stockSapPending': '(SAP integration pending)',
  'admin.productForm.stockSapSync': 'Synchronized via SAP',
  'admin.productForm.minOrderQuantity': 'Minimum Order Quantity',
  'admin.productForm.imageUrl': 'Image URL (optional)',
  'admin.productForm.isActive': 'Product is active and visible',
  'admin.productForm.detailsSection': 'Product Details (for Detail Page)',
  'admin.productForm.manufacturer': 'Manufacturer',
  'admin.productForm.manufacturerPartNo': 'Manufacturer Part No.',
  'admin.productForm.purchasingGroup': 'Purchasing Group',
  'admin.productForm.plannedDeliveryTime': 'Planned Delivery Time',
  'admin.productForm.priceSource': 'Price Source',
  'admin.productForm.priceSourceNone': 'Not specified',
  'admin.productForm.priceSourceContract': 'Contract Price',
  'admin.productForm.priceSourceInforecordPlant': 'Info Record Plant-Specific',
  'admin.productForm.priceSourceInforecordGeneral': 'Info Record General',
  'admin.productForm.priceSourceEstimate': 'Estimated Price',
  'admin.productForm.priceSourceInternal': 'Internal Shop Price',
  'admin.productForm.technicalAttributes': 'Technical Attributes',
  'admin.productForm.priceScales': 'Price Scales',
  'admin.productForm.contractData': 'Contract Data',
  'admin.productForm.documents': 'Documents',
  'admin.productForm.compliance': 'Compliance / Standards',
  // F7: JSON table editor
  'admin.jsonEditor.addRow': '+ Row',
  'admin.jsonEditor.removeRow': 'Remove row',
  'admin.jsonEditor.empty': 'No entries yet — click "+ Row" to add.',
  'admin.jsonEditor.attrLabel': 'Attribute',
  'admin.jsonEditor.attrValue': 'Value',
  'admin.jsonEditor.attrUnit': 'Unit',
  'admin.jsonEditor.attrGroup': 'Group',
  'admin.jsonEditor.scaleQty': 'from Qty',
  'admin.jsonEditor.scalePrice': 'Price',
  'admin.jsonEditor.docType': 'Type',
  'admin.jsonEditor.docTitle': 'Title',
  'admin.jsonEditor.docFormat': 'Format',
  'admin.jsonEditor.docUrl': 'URL',
  'admin.jsonEditor.compLabel': 'Standard',
  'admin.jsonEditor.contractExists': 'Contract exists',
  'admin.jsonEditor.contractNumber': 'Contract number',
  'admin.jsonEditor.contractItem': 'Item',
  'admin.jsonEditor.contractType': 'Contract type',
  'admin.jsonEditor.contractValidFrom': 'Valid from',
  'admin.jsonEditor.contractValidTo': 'Valid to',
  'admin.jsonEditor.contractTargetQty': 'Target qty',
  'admin.jsonEditor.contractTargetValue': 'Target value',
  'admin.jsonEditor.contractPrice': 'Contract price',
  'admin.productForm.attributes.title': 'Technical Characteristics',
  'admin.productForm.attributes.label': 'Label',
  'admin.productForm.attributes.value': 'Value',
  'admin.productForm.attributes.unit': 'Unit',
  'admin.productForm.attributes.charName': 'Tech. Name',
  'admin.productForm.attributes.addRow': 'Add characteristic',
  'admin.productForm.attributes.removeRow': 'Remove row',
  'admin.productForm.attributes.empty': 'No technical characteristics defined yet.',
};

export default admin;
